"use client";
import React, { Suspense, lazy } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import LoadingSpinner from "@/components/LoadingSpinner";

// Lazy loading de componentes
const Header65 = lazy(() => import("@/components/servicios/Header65").then(m => ({ default: m.Header65 })));
const Layout237 = lazy(() => import("@/components/servicios/Layout237").then(m => ({ default: m.Layout237 })));

export default function Page() {
  return (
    <div>
      <Navbar />
      
      <Suspense fallback={<LoadingSpinner text="Cargando información de servicios..." className="py-20" />}>
        <Header65 />
      </Suspense>
      
      <Suspense fallback={<LoadingSpinner text="Cargando servicios disponibles..." className="py-12" />}>
        <Layout237 />
      </Suspense>
      
      <Footer />
    </div>
  );
}
